import { doDelete, doGet, doPost, doPut } from "../../../api/baseAPI";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { setTableLoading } from '../../../store/reducer/page.reducer'
import { checkValidationToken } from "../../../util/errorHandler";

export const getListAddressFormatConfig = async (token, refresh_token, param, dispatch) => {
    const url = `${GROLOG_URL}/address-format-configuration?page=1`;
    let result = { data: undefined, ok: false }

    dispatch(setTableLoading(true))
    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    dispatch(setTableLoading(false))
    return result
}

export const editAddressFormatConfig = async (token, refresh_token, data, dispatch) => {
    const url = `${GROLOG_URL}/address-format-configuration/edit`
    let result = { data: undefined, ok: false }

    try {
        const response = await doPut(url, token, data)
        if (response) {
            result.ok = true
            result.data = response?.data?.payload?.data
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}

export const getManagementHistoryList = async (token, refresh_token, dispatch) => {
    const url = `${GROLOG_BASE_URL}/audit/v1/grolog/audit?page=1&filter=table_name eq address_format_configuration`;
    let result = { data: undefined, ok: false }

    try {
        const response = await doGet(token, url, null);
        if (response) {
            result.ok = true;
            result.data = response?.data?.payload
        }
    } catch (error) {
        checkValidationToken(error, token, refresh_token, dispatch)
    }
    return result
}